// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.style-option-container[data-v-3dcf66a2] {\n  height: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
